// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emptyState__leFcQCKInF{width:100%}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/contacts/components/details/components/contactsEmptyState/contactsEmptyState.module.scss"],"names":[],"mappings":"AAAA,wBACE,UAAA","sourcesContent":[".emptyState {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": `emptyState__leFcQCKInF`
};
export default ___CSS_LOADER_EXPORT___;
